import styled from 'styled-components';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';
import { colors, spacing } from 'ui/theme';
import { button } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';

type StyledHeaderButtonProps = {
  isActiveSortColumn: boolean;
  isSortable: boolean;
};

export const HeaderButton = styled.button`
  ${button}
  align-items: center;
  background: none;
  border: none;
  color: ${(props: StyledHeaderButtonProps) =>
    props.isActiveSortColumn ? colors.purple100 : colors.textPrimary};
  cursor: ${(props: StyledHeaderButtonProps) => (props.isSortable ? 'pointer' : 'default')};
  display: flex;
  outline: none;
  padding: ${spacing.half} 0;
  pointer-events: ${(props: StyledHeaderButtonProps) => (props.isSortable ? 'auto' : 'none')};
  text-align: left;

  span {
    display: inline-block;
    margin-right: ${spacing.quarter};
  }
`;

export const StyledGroupSelect = styled(GroupSelect)`
  margin-left: -${pxToRem(9)};
`;

export const TableCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
`;
